// ============================================
// INFRASTRUCTURE - Ventas Repository
// ============================================

import { axiosClient } from './axios-client';
import type { CrearVentaPosDto, CrearVentaPosResponse, CrearVentaMultiPagoDto } from '../../domain/dtos';

export interface BoletaDetallePrint {
  boletaId: number;
  siiDteEmitidoId: number | null;
  siiFolio: number | null;
  contribuyenteRazonSocial: string;
  contribuyenteGiro: string;
  rut: string;
  nombreAlmacen: string;
  direccionAlmacen: string;
  logoUrl: string | null;
  numeroLocal: string | null;
  fecha: string;
  details: Array<{
    nombreProducto: string;
    cantidad: number;
    precioUnitario: number;
    /** Monto de la línea neto de descuento (el cobrado y el que va al DTE). */
    total: number;
    /** Descuento de la línea en CLP. */
    descuento?: number;
    /** Monto de la línea a precio de lista, antes del descuento. */
    subtotalSinDescuento?: number;
  }>;
  iva: number;
  descuento: number;
  /** Suma de los montos de línea a precio de lista, antes de descuentos. */
  subtotalSinDescuento?: number;
  total: number;
  electronicReceipt: boolean;
}

export const ventasRepository = {
  /**
   * Crear una nueva venta (POS)
   */
  async crearVenta(dto: CrearVentaPosDto): Promise<CrearVentaPosResponse> {
    const { data } = await axiosClient.post('/sales', dto);
    return data;
  },

  /**
   * Crear una nueva venta con múltiples medios de pago
   */
  async crearVentaMultiPago(dto: CrearVentaMultiPagoDto): Promise<CrearVentaPosResponse> {
    const { data } = await axiosClient.post('/sales/multi-payment', dto);
    return data;
  },

  /**
   * Enviar boleta por email
   */
  async enviarBoletaPorEmail(boletaId: number, email: string): Promise<void> {
    await axiosClient.post(`/sales/${boletaId}/send-email`, { email });
  },

  /**
   * Obtener datos de boleta para imprimir
   */
  async obtenerBoletaParaImprimir(boletaId: number): Promise<BoletaDetallePrint> {
    const { data } = await axiosClient.get(`/ventas/${boletaId}/print`);
    return data;
  },
};
